export default "__VITE_ASSET__DsBTHvQ5__"